import { DeleteButton, ImportGeojsonButton, PolygonPassingModeButton, RedoButton, SelectButton, ToolbarConfig, UndoButton } from "fond/map/Toolbar";

/**
 * Toolbar for carving areas only
 */
export const carveToolbarConfig: ToolbarConfig = [
  {
    id: "mainActions",
    type: "mode",
    items: [<SelectButton key="select" />, <PolygonPassingModeButton key="carve" title="Identify workarea" />],
  },
  {
    id: "importTools",
    type: "action",
    items: [<ImportGeojsonButton key="import" />],
  },
  {
    id: "historyTools",
    type: "action",
    items: [<UndoButton key="undo" />, <RedoButton key="redo" />, <DeleteButton key="delete" />],
  },
];
